import { createFileRoute } from "@tanstack/react-router";
import { CalendarPage } from "@/features/portalmore/CalendarPage";

/** Portal calendar of meetings and bookings (P109). */
export const Route = createFileRoute("/portal/calendar")({
  component: CalendarPage,
});
